import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useUserGrantsContext } from "features/user/hooks/useUserGrantsContext";
import { operationNameMap } from "features/user/constants";
import { checkOperationPermission } from "features/auth/utils/checkOperationPermission";

export const useProtectedRoute = () => {
  const { pathname } = useLocation();
  const { userGrants } = useUserGrantsContext();

  const routeComponentMap = new Map([
    [
      "external-import",
      {
        component: "Internal List with HZ-File (extern)",
        function: "IMPORT_EXT",
      },
    ],
    [
      "internal-import",
      {
        component: "Internal List with Host-File (intern)",
        function: "IMPORT_INT",
      },
    ],
    [
      "external-reconciliation",
      {
        component: "Internal List with HZ-File (extern)",
        function: "RECON_EXT",
      },
    ],
    [
      "internal-reconciliation",
      {
        component: "Internal List with Host-File (intern)",
        function: "RECON_INT",
      },
    ],
    [
      "external-statistics",
      {
        component: "Internal List with HZ-File (extern)",
        function: "STAT_EXT",
      },
    ],
    [
      "internal-statistics",
      {
        component: "Internal List with Host-File (intern)",
        function: "STAT_INT",
      },
    ],
    [
      "client-export",
      {
        component: "Client data export",
        function: "EXPORT",
      },
    ],
  ]);

  const route = pathname.split("/")[1];
  const component = routeComponentMap.get(route)?.component ?? "";
  const func = routeComponentMap.get(route)?.function ?? "";
  const operationName = pathname.split("/")[2];
  const operation = operationNameMap[operationName] || operationNameMap.read;

  const isPermittedRoute = useMemo(
    () =>
      checkOperationPermission({
        operation,
        component,
        func,
        userGrants: userGrants ?? [],
      }),
    [operation, component, func, userGrants]
  );

  return {
    isPermittedRoute,
    userGrants,
  };
};
